import React from 'react';
import PropTypes from 'prop-types';
import Card from '../shared/Card';

const RoomUpgradeItem = ({
  item,
  startingPrice,
  isSelected,
  onAdd,
  onRemove,
  itemimg,
}) => {
  return (
    <Card
      title={item.display_name}
      startingPrice={startingPrice}
      hideStartingAtLabel
    >
      <div className="extras-item__body">
        <img src={itemimg} width={150} alt={item.name} />
        <p>{item.description}</p>
      </div>

      {!isSelected ? (
        <button className="extras-item__button" onClick={onAdd}>
          Select
        </button>
      ) : (
        <button
          className="extras-item__button field__input--selected"
          onClick={onRemove}
        >
          Remove
        </button>
      )}
    </Card>
  );
};

RoomUpgradeItem.propTypes = {
  item: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  startingPrice: PropTypes.number.isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default RoomUpgradeItem;
